import { Component, OnDestroy, OnInit, HostBinding, HostListener, ViewEncapsulation } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';

import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

import { AuthenticationService } from 'app/auth/service';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { CoreConfigService } from '@core/services/config.service';
import { CoreMediaService } from '@core/services/media.service';

import { coreConfig } from 'app/app-config';
import { Router } from '@angular/router';
import {environment} from "../../../../environments/environment";
import {Users} from "../../../main/pages/_sommavi/models/Users";
import {APP_NAME} from "../../../main/pages/_sommavi/models/constantesMessages";
import {UsersService} from "../../../services/users.service";
import {UtilisateursService} from "../../../main/pages/_sommavi/services/utilisateurs.service";
import {UtilsService} from "../../../utils/utils.service";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NavbarComponent implements OnInit, OnDestroy {
  public horizontalMenu: boolean;
  public hiddenMenu: boolean;

  AppName = APP_NAME;

  public coreConfig: any;
  public currentSkin: string;
  public prevSkin: string;
  public env = environment;
  public currentUser: Users;
  public fullName: string;
  public photo: string;
  public languageOptions: any;
  public navigation: any;
  public selectedLanguage: any;

  @HostBinding('class.fixed-top')
  public isFixed = false;

  @HostBinding('class.navbar-static-style-on-scroll')
  public windowScrolled = false;

  // Add .navbar-static-style-on-scroll on scroll using HostListener & HostBinding
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (
      (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 100) &&
      this.coreConfig.layout.navbar.type == 'navbar-static-top' &&
      this.coreConfig.layout.type == 'horizontal'
    ) {
      this.windowScrolled = true;
    } else if (
      (this.windowScrolled && window.pageYOffset) ||
      document.documentElement.scrollTop ||
      document.body.scrollTop < 10
    ) {
      this.windowScrolled = false;
    }
  }

  // Private
  private _unsubscribeAll: Subject<any>;

  CurrentUser = JSON.parse(sessionStorage.getItem("currentUser"));

  _currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  PagePermissions={
    //--
    departement_cadre_read:false,
    departement_read: false,
    departement_create: false,
    division_read: false,
    division_create: false,
    //--
    emplacement_cadre_read:false,
    emplacement_read: false,
    emplacement_create: false,
    sousEmplacement_read: false,
    sousEmplacement_create: false,
    //--
    user_cadre_read:false,
    user_read: false,
    user_create: false,
    cadre_read: false,
    //--
    article_cadre_read:false,
    article_read: false,
    article_create: false,

    famille_read: false,
    famille_create: false,

    sousFamille_read: false,
    sousFamille_create: false,
    //--
    fournisseur_cadre_read: false,
    fournisseur_read: false,
    fournisseur_create: false,

  }

  /**
   * Constructor
   *
   * @param {Router} _router
   * @param {AuthenticationService} _authenticationService
   * @param {CoreConfigService} _coreConfigService
   * @param {CoreSidebarService} _coreSidebarService
   * @param {CoreMediaService} _coreMediaService
   * @param {MediaObserver} _mediaObserver
   * @param {TranslateService} _translateService
   */
  constructor(
    private _router: Router,
    private _userService: UtilisateursService,
    private _authenticationService: AuthenticationService,
    private _coreConfigService: CoreConfigService,
    private _coreMediaService: CoreMediaService,
    private _coreSidebarService: CoreSidebarService,
    private _mediaObserver: MediaObserver,
    public _translateService: TranslateService
  ) {
    //-> SUIT LA CONNEXION / DECONNEXION SANS RECHARGER LA PAGE
    this._authenticationService.currentUser.subscribe(x => {
      this.currentUser = x;
      this.CurrentUser = x;
      this._currentUser = x;
    });
    this.fullName = '';//this.currentUser?.fullName;
    this.photo = '';//this.currentUser?.photo;
    this.languageOptions = {
      en: {
        title: 'English',
        flag: 'us'
      },
      fr: {
        title: 'French',
        flag: 'fr'
      },
      de: {
        title: 'German',
        flag: 'de'
      },
      pt: {
        title: 'Portuguese',
        flag: 'pt'
      }
    };

    // Set the private defaults
    this._unsubscribeAll = new Subject();

    //PERMISSIONS CHECKING -FUNCTION CALL
    Object.entries(this.PagePermissions).map((p, index) => this.PermissionChecking(p, index));
  }

  // Public Methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle sidebar open
   *
   * @param key
   */
  toggleSidebar(key): void {
    this._coreSidebarService.getSidebarRegistry(key).toggleOpen();
  }

  /**
   * Set the language
   *
   * @param language
   */
  setLanguage(language): void {
    // Set the selected language for the navbar on change
    this.selectedLanguage = language;

    // Use the selected language id for translations
    this._translateService.use(language);

    this._coreConfigService.setConfig({ app: { appLanguage: language } }, { emitEvent: true });
  }

  /**
   * Toggle Dark Skin
   */
  toggleDarkSkin() {
    // Get the current skin
    this._coreConfigService
      .getConfig()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(config => {
        this.currentSkin = config.layout.skin;
      });

    // Toggle Dark skin with prevSkin skin
    this.prevSkin = localStorage.getItem('prevSkin');

    if (this.currentSkin === 'dark') {
      this._coreConfigService.setConfig(
        { layout: { skin: this.prevSkin ? this.prevSkin : 'default' } },
        { emitEvent: true }
      );
    } else {
      localStorage.setItem('prevSkin', this.currentSkin);
      this._coreConfigService.setConfig({ layout: { skin: 'dark' } }, { emitEvent: true });
    }
  }

  /**
   * Logout method
   */
  refeshMyDatas() {
    this._userService.getUserById(this.CurrentUser.id).subscribe(refeshResponse =>{
      //-> MENU, MAGASINS ET PERMISSIONS SE METTENT A JOUR SANS RECHARGER LA PAGE
      this._authenticationService.mettreAJourUtilisateur(refeshResponse);
    }, error => {
      UtilsService.AlertMessageHandler(error);
    });
  }

  /**
   * Logout method
   */
  logout() {
    this._authenticationService.logout();
    this._router.navigate(['/pages/authentication/login']);
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // get the currentUser details from localStorage
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));

    // Subscribe to the config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
      this.horizontalMenu = config.layout.type === 'horizontal';
      this.hiddenMenu = config.layout.menu.hidden === true;
      this.currentSkin = config.layout.skin;

      // Fix: for vertical layout if default navbar fixed-top than set isFixed = true
      if (this.coreConfig.layout.type === 'vertical') {
        setTimeout(() => {
          if (this.coreConfig.layout.navbar.type === 'fixed-top') {
            this.isFixed = true;
          }
        }, 0);
      }
    });

    // Horizontal Layout Only: Add class fixed-top to navbar below large screen
    if (this.coreConfig.layout.type == 'horizontal') {
      // On every media(screen) change
      this._coreMediaService.onMediaUpdate.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
        const isFixedTop = this._mediaObserver.isActive('bs-gt-xl');
        if (isFixedTop) {
          this.isFixed = false;
        } else {
          this.isFixed = true;
        }
      });
    }

    // Set the selected language from default languageOptions
    this.selectedLanguage = _.find(this.languageOptions, {
      id: this._translateService.currentLang
    });
  }

  //====================================================================================
  //- PERMISSIONS ET INITIALISATION  -FUNCTIONS
  //====================================================================================
  PermissionChecking(namePermission, index){
    // console.log("this._currentUser -> ", this._currentUser);
    if(!this._currentUser){
      return;
    }
    this._currentUser.permissions.map(p =>{
      if (p.nom === namePermission[0]){
        this.PagePermissions[namePermission[0]] = true;
      }});
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
